import { useContext } from "react";

import TableContext from "context/table/tableContext";
import { useMediaQueries, usePermissions } from "shared";

import { TOOLTIP_PLACEMENT, TooltipGeneral } from "../Tooltips";
import { ActionToolbarButtonWrapperProps } from "./types";

const ActionToolbarButtonWrapper = ({
    children,
    customTooltipTitle,
    permissionName
}: ActionToolbarButtonWrapperProps) => {
    const { isInitialLoading } = useContext(TableContext);

    const { toSm } = useMediaQueries();
    const { getNoPermissionTooltipTitle } = usePermissions();

    const renderContent = () => {
        if (!toSm && isInitialLoading) {
            return;
        }

        if (permissionName) {
            const permissionsArray = Array.isArray(permissionName)
                ? permissionName
                : [permissionName];

            return (
                <TooltipGeneral
                    title={
                        customTooltipTitle ??
                        getNoPermissionTooltipTitle(permissionsArray)
                    }
                    placement={TOOLTIP_PLACEMENT.Top}
                >
                    <span>{children}</span>
                </TooltipGeneral>
            );
        }

        return children;
    };

    return <>{renderContent()}</>;
};

export default ActionToolbarButtonWrapper;
